/* eslint-disable max-len */
export interface DynamicConfig {
    name: string;
    version: string;
    environment: 'DEV' | 'TST' | 'AKC' | 'PROD';
    serviceText: boolean;
    api: {
        baseURL: string;
        apiURL: string;
        timeout: number;
    };
}

// Default config, který je použit v případě neúspěšného načtení global configu na vývojovém prostředí
export const defaultConfig: DynamicConfig = {
    name: '[DEV] NZD',
    version: '1.0.0',
    environment: 'DEV',
    serviceText: true,
    api: {
        baseURL: 'http://localhost:3000/',
        apiURL: 'http://localhost:3000/',
        timeout: 60000
    }
};

class GlobalConfig {
    config: DynamicConfig = defaultConfig;
    notDefinedYet = true;

    public get(): DynamicConfig {
        if (this.notDefinedYet) {
            throw new Error(
                'Global config nebyl definován. Tato metoda musí být zavolána až po úspěšném načtení konfigurace. Pravděpodobná příčina je přístup ke globalConfigu ve formě statického kontextu.'
            );
        } else {
            return this.config;
        }
    }

    public set(value: DynamicConfig): void {
        if (this.notDefinedYet) {
            this.config = value;
            this.notDefinedYet = false;
        } else {
            throw new Error(
                'Global config byl již definován a je nyní definován podruhé. Tohle velmi pravděpodobně nebylo v úmyslu.'
            );
        }
    }
}

export const globalConfig = new GlobalConfig();

export const globalConfigUrl = 'config.json';
